import React from 'react';
import { Box } from 'grommet';

export const ViewTabContent = ({ ...rest }) => (
  <Box pad={{ vertical: 'medium' }} {...rest} />
);